import { useEffect, useState } from "react";
import { initLenis } from "../lib/smooth";
import { getSiteSettings } from "../lib/api";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { StatsStrip } from "../components/StatsStrip";
import { Highlights } from "../components/Highlights";
import { ApartmentHighlights } from "../components/ApartmentHighlights";
import { Sustainability } from "../components/Sustainability";
import { Masterplan } from "../components/Masterplan";
import { FloorPlans } from "../components/FloorPlans";
import { LocationSection } from "../components/LocationSection";
import { Specifications } from "../components/Specifications";
import { Developer } from "../components/Developer";
import { PricingCta } from "../components/PricingCta";
import { Faq } from "../components/Faq";
import { ContactFooter } from "../components/ContactFooter";
import { LeadModal } from "../components/LeadForm";
import { StickyMobileBar, WhatsAppFloat } from "../components/StickyElements";

export default function Landing() {
  const [modal, setModal] = useState({ open: false, source: "Enquiry", interest: "" });
  const [contact, setContact] = useState({ phone: "+919163841785", whatsapp: "+919163841785" });

  useEffect(() => {
    initLenis();
    getSiteSettings().then(setContact);
  }, []);

  const openModal = (source, interest = "") => setModal({ open: true, source, interest });
  const closeModal = () => setModal((m) => ({ ...m, open: false }));

  return (
    <div className="bg-[#FFFFFF]" data-testid="landing-page">
      <Header onBookVisit={() => openModal("Site Visit Booking")} phone={contact.phone} />
      <main>
        <Hero
          onPrice={() => openModal("Get Latest Price")}
          onVisit={() => openModal("Site Visit Booking")}
          phone={contact.phone}
        />
        <Marquee />
        <StatsStrip />
        <Highlights />
        <ApartmentHighlights />
        <Sustainability />
        <Masterplan />
        <FloorPlans onEnquire={(config, source) => openModal(`${source}: ${config}`, config.startsWith("2") ? "2 BHK" : "3 BHK")} />
        <LocationSection />
        <Specifications />
        <Developer />
        <PricingCta
          onPrice={() => openModal("Get Latest Price")}
          onVisit={() => openModal("Site Visit Booking")}
        />
        <Faq />
        <ContactFooter phone={contact.phone} whatsapp={contact.whatsapp} />
      </main>
      <LeadModal open={modal.open} onClose={closeModal} source={modal.source} defaultInterest={modal.interest} whatsapp={contact.whatsapp} />
      <StickyMobileBar phone={contact.phone} whatsapp={contact.whatsapp} onEnquire={() => openModal("Quick Enquiry")} />
      <WhatsAppFloat whatsapp={contact.whatsapp} />
    </div>
  );
}
